var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar border-1px"},[_c('ul',_vm._l((_vm.tagNames),function(tagName){return _c('li',[_c('router-link',{attrs:{"tag":"div","to":tagName.tabLink,"replace":""}},[_c('span',[_vm._v(_vm._s(tagName.title1))])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-5387b2cb","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/base/navBar.vue
// module id = 1350
// module chunks = 382